function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.061 1.061l5.887 5.886-5.887 5.886"
});

function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 9.068,
    height: 13.894
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHdpZHRoPSI5LjA2OCIgaGVpZ2h0PSIxMy44OTQiIHZpZXdCb3g9IjAgMCA5LjA2OCAxMy44OTQiPjxwYXRoIGQ9Ik05MzYzLjYsMzkwOS42bDUuODg3LDUuODg2LTUuODg3LDUuODg2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTM2Mi41MzkgLTM5MDguNTM5KSIvPjwvc3ZnPg==";
export { SvgCaret as ReactComponent };